import * as GetSearch from './getSearch.js'
import {getIndividuation, setIndividuation} from './toIndividuation.js'
// 判断平台类型：一体机、pc
function getPlatform(){
  const useragent = navigator.userAgent;
  return (useragent.toLowerCase().indexOf('androidpc') > -1)
}

const getSearch = GetSearch.getSearch;
const URLSearchCodes = GetSearch.default;
export default {getPlatform, getSearch, URLSearchCodes, getIndividuation, setIndividuation};
// 获取个性化标识

// 缓存管理



// WEBPACK FOOTER //
// ./src/utils/index.js